import React, { useState } from 'react';
import myIcon from '../../assets/icons/sideMenuArrow.svg';
import {
  ConfigPage,
  GroupsConfig,
  LanguageConfig,
  SideMenu,
  Templates,
  UsersConfig,
} from './page1/components';
import Page1 from './page1';

export default function AdminPage() {
  const [sectionSelected, setSectionSelected] = useState(0);
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(true);

  const toggleSideMenu = () => {
    setIsSideMenuVisible(prev => !prev);
  };

  return (
    <div className="apptrack-wrapper">
      <div className={`d-flex admin-page-body`}>
        <div
          onClick={toggleSideMenu}
          className={`toggle-menu ${
            isSideMenuVisible ? '' : 'toggle-menu-open'
          }`}
        >
          <img src={myIcon} alt="Toggle" />
        </div>
        <div id="admin-side-menu">
          <SideMenu sectionSelected={sectionSelected} setSectionSelected={setSectionSelected}/>
        </div>

        <div id="admin-main-content">
          {sectionSelected == 0 && <Page1></Page1>}
          {sectionSelected == 1 && <ConfigPage></ConfigPage>}
          {sectionSelected == 2 && <Templates></Templates>}
          {sectionSelected == 3 && <LanguageConfig></LanguageConfig>}
          {sectionSelected == 4 && <UsersConfig></UsersConfig>}
          {sectionSelected == 5 && <GroupsConfig></GroupsConfig>}
        </div>
      </div>
    </div>
  );
}
